<div class="outerContainer">
  <div class="overlay"></div>

  <nz-card class="loginCard">
    <div class="reg-log-form-inner">
      <img
        src="/assets/images/loginLogo.png"
        alt="Mockshala Logo"
        class="login-logo"
      />

      <h2 class="loginHeader" *ngIf="!isOtpSend">Forgot Password</h2>

      <h2 class="loginHeader" *ngIf="isOtpSend">Reset Password</h2>

      <form nz-form [formGroup]="forgotPasswordForm" class="login-form">
        <!-- Email -->
        <nz-form-item class="loginfld">
          <nz-form-control [nzErrorTip]="errorTplEmail">
            <input
              nz-input
              type="text"
              formControlName="email"
              placeholder="Email address"
              [readOnly]="isOtpSend"
            />
            <ng-template #errorTplEmail let-control>
              <span *ngIf="control.hasError('required')">
                Email is required
              </span>
              <span *ngIf="control.hasError('pattern')">
                Enter a valid email
              </span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <!-- OTP -->
        <nz-form-item *ngIf="isOtpSend" class="loginfld">
          <nz-form-control nzErrorTip="OTP is required">
            <input
              nz-input
              type="text"
              formControlName="otp"
              placeholder="Enter OTP"
            />
          </nz-form-control>
        </nz-form-item>

        <!-- OTP Info -->
        <div class="otp-info" *ngIf="isOtpSend">
          <p *ngIf="!showButton">
            Resend OTP in {{ countdownInMinute }}:{{ countdownInSec }} sec
          </p>
          <button
            nz-button
            nzType="link"
            *ngIf="showButton"
            [nzLoading]="isLoading"
            (click)="resendOTP()"
          >
            Resend OTP
          </button>
        </div>

        <!-- New Password -->
        <nz-form-item *ngIf="isOtpSend" class="loginfld">
          <nz-form-control nzErrorTip="Password is required">
            <div class="password-wrapper">
              <input
                nz-input
                [type]="!viewPassword ? 'password' : 'text'"
                formControlName="password"
                placeholder="New Password"
                (ngModelChange)="updateConfirmValidator()"
              />
              <span
                nz-icon
                class="eye-icon"
                nzTheme="outline"
                [nzType]="!viewPassword ? 'eye' : 'eye-invisible'"
                (click)="viewPassword = !viewPassword"
              ></span>
            </div>
          </nz-form-control>
        </nz-form-item>

        <!-- Confirm Password -->
        <nz-form-item *ngIf="isOtpSend" class="loginfld">
          <nz-form-control [nzErrorTip]="errorTpl">
            <div class="password-wrapper">
              <input
                nz-input
                [type]="!viewReEnterPassword ? 'password' : 'text'"
                formControlName="reEnterPassword"
                placeholder="Confirm Password"
              />
              <span
                nz-icon
                class="eye-icon"
                nzTheme="outline"
                [nzType]="!viewReEnterPassword ? 'eye' : 'eye-invisible'"
                (click)="viewReEnterPassword = !viewReEnterPassword"
              ></span>
            </div>

            <ng-template #errorTpl let-control>
              <span *ngIf="control.hasError('required')">
                Confirm password is required
              </span>
              <span *ngIf="control.hasError('confirm')">
                Passwords do not match
              </span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <!-- Buttons -->
        <button
          nz-button
          nzType="primary"
          class="login-form-button"
          *ngIf="!isOtpSend"
          [nzLoading]="isLoading"
          (click)="sendOTP()"
        >
          Next
        </button>

        <button
          nz-button
          nzType="primary"
          class="login-form-button"
          *ngIf="isOtpSend"
          [nzLoading]="isLoading"
          (click)="submitForResetPassword()"
        >
          Submit
        </button>
      </form>
    </div>
  </nz-card>
</div>
